import React, { Component } from "react";
import sanityClient from "./PreviewClient";
import BlockContent from "@sanity/block-content-to-react";
import imageUrlBuilder from "@sanity/image-url";
import { CommonUtil } from '../utils/CommonUtil';

const builder = imageUrlBuilder(sanityClient);
class PreviewPost extends Component {
  constructor(props) {
    super(props);
    this.state = {
      postData: {}
    }
    this.translateLang = CommonUtil.lang;
    this.serializers = {
      types: {
        mainImage: (props) => (
          <div className="blog-detail-image">
              <img src={this.urlFor(props.node).url()} alt="" />
          </div>
        ),
      },
    };
  }
  componentDidMount() {      
    this.fetchBlog();
  }
  componentDidUpdate(prevProps) {
    if(this.translateLang !== CommonUtil.lang) {
      this.translateLang = CommonUtil.lang;
      this.fetchBlog();      
    }
  }
  urlFor(source) {
    return builder.image(source);
  }
  fetchBlog() {
    let lang = CommonUtil.lang.split("-")[0];
    const slug = this.props.match.params.slug;
    sanityClient.fetch(
      `*[slug.current == $slug]{
        "title": title["${lang}"],
        slug,
        mainImage{
          asset->{
            _id,
            url
            }
          },
        "body": body["${lang}"],
        authors[]{
            author->{
                image,
                name
            }
        }
      }`,
      { slug }
    ).then((data) => {
      this.setState(c => {
        c.postData = data[0];
        return c;
      })
    }).catch(console.error);
  }
  render() {
    let postData = this.state.postData;
    if (!postData) return <div>Loading...</div>;
    let author = (postData.authors && postData.authors.length > 0) ? postData.authors[0].author : {};
    return (
      <div>
        <div >
          <h2>{postData.title}</h2>
          <div className="writer-info">
            <div className="write-info-pic">
              <img
                  src={this.urlFor(author.image).width(20).url()}
                  alt={author.name}
              />
            </div>
            <div className="write-info-name">
                <span>{author.name}</span>
            </div>
          </div>
        </div>
        <div className="blog-main-img">
            <img src={this.urlFor(postData.mainImage).url()} alt="" />
        </div>
        <div>
          <BlockContent
            blocks={postData.body}
            projectId={sanityClient.config().projectId}
            dataset={sanityClient.config().dataset}
            serializers={this.serializers}
          />
        </div>
      </div>
    );    
  }
}
export default PreviewPost
